import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Grid } from "@mui/material";

export default function MultipleChoiceImage({ question, onAnswer = () => {} }) {
	const theme = useTheme();
	const [selectedAnswers, setSelectedAnswers] = React.useState([]);
	//   const [loggedAnswers, setLoggedAnswers] = React.useState([]);

	React.useEffect(() => {
		setSelectedAnswers([]);
	}, [question]);

	const handleSetAnswer = (j, ansText) => {
		let updatedAnswers;

		if (selectedAnswers.includes(j)) {
			updatedAnswers = selectedAnswers.filter((answer) => answer !== j);
		} else {
			updatedAnswers = [...selectedAnswers, j];
		}

		setSelectedAnswers(updatedAnswers);

		const newLoggedAnswers = updatedAnswers.map((index) =>
			question.questionList[0].choices[index].value.trim()
		);
		// setLoggedAnswers(newLoggedAnswers);

		onAnswer({
			canProceed: newLoggedAnswers.length > 0,
			answer: newLoggedAnswers,
		});
	};

	return (
		<React.Fragment>
			<Box
				className="choices-container"
				sx={{ px: 4, textAlign: "center" }}
			>
				{question.questionList.map((k, i) => (
					<Grid
						container
						sx={{ mt: 2 }}
						key={`image-question-${i}-${Math.random()}`}
					>
						{k.choices.map((choice, j) => (
							<Grid
								item
								sm={12}
								xs={12}
								sx={{
									mt: 2,
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
								}}
								className={`image-question-container ${
									selectedAnswers.includes(j) ? "active" : ""
								}`}
								key={`choice-${i}-${j}`}
								onClick={() => handleSetAnswer(j, choice.value)}
							>
								<Box
									sx={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										flexDirection: "column",
										cursor: "pointer",
										border: selectedAnswers.includes(j)
											? `2px solid ${theme.palette.primary.main}`
											: "2px solid transparent",
										borderRadius: "8px",
										padding: "0.5rem",
									}}
								>
									<img
										src={choice.image}
										alt={choice.value}
										style={{
											maxWidth: "11rem",
											maxHeight: "5.5rem",
											objectFit: "contain",
										}}
									/>
								</Box>
							</Grid>
						))}
					</Grid>
				))}
			</Box>
		</React.Fragment>
	);
}
